import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions
} from '@angular/material/dialog';
import { Payment } from '../../../models/payment';
import { PaymentService } from '../../services/payment.service';
import { ConfigService } from '../../services/config.service';
import { DepotLocation } from '../../../models';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MomentModule } from 'ngx-moment';
import { UserIdToNamePipe } from '../../pipes/user-id-to-name.pipe';
import { MatInput } from '@angular/material/input';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatFormField } from '@angular/material/form-field';
import { FlexModule } from '@angular/flex-layout';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton, MatButton } from '@angular/material/button';
import { NgIf, NgFor, AsyncPipe, CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-add-payment-dialog',
  templateUrl: './add-payment-dialog.component.html',
  styleUrls: ['./add-payment-dialog.component.css'],
  providers: [PaymentService],
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    NgIf,
    NgFor,
    MatIconButton,
    MatIcon,
    ReactiveFormsModule,
    FormsModule,
    FlexModule,
    MatFormField,
    MatSelect,
    MatOption,
    MatInput,
    MatDialogActions,
    MatButton,
    AsyncPipe,
    CurrencyPipe,
    UserIdToNamePipe,
    MomentModule
  ]
})
export class AddPaymentDialogComponent implements OnInit, OnDestroy {
  payments: Array<Payment>;
  paymentableId: number;
  paymentableType: string;
  newPayment: any = {
    method: '',
    amount: ''
  };
  methods = [
    { id: 1, name: 'Cash' },
    { id: 2, name: 'Cheque' },
    { id: 3, name: 'Card' },
    { id: 3, name: 'Bank Transfer' }
  ];
  balance: number;
  paid: number;
  dateTimeFormat = ConfigService.dates.longDateTimeFormat;
  defaultCurrency = 'GBP';
  currency = 'GBP';
  currencyRate = 1;
  private ngUnsubscribe = new Subject<void>();
  currentLcation: DepotLocation;

  constructor(
    public dialogRef: MatDialogRef<AddPaymentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private paymentService: PaymentService,
    private configService: ConfigService
  ) {
    this.payments = data.payments;
    this.paymentableId = data.paymentableId;
    this.paymentableType = data.paymentableType;
    this.balance = data.balance;
    this.defaultCurrency = data.defaultCurrency;
    this.currency = data.currency;
    this.currencyRate = data.currencyRate;
    this.configService.currentLocation
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((location) => {
        this.currentLcation = location;
      });
  }

  ngOnInit() {
    this.sumPaid();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  save() {
    if (!this.newPayment.method || !this.newPayment.amount) {
      return;
    }
    const update = { ...this.newPayment };
    update.paymentable_type = this.paymentableType;
    update.location_id = this.currentLcation.id;
    update.amount = parseFloat(update.amount) / this.currencyRate;

    this.paymentService
      .create(this.paymentableType, this.paymentableId, update)
      .subscribe((response) => {
        this.dialogRef.close(response);
      });
  }

  delete(payment) {
    this.paymentService
      .delete(this.paymentableId, payment.id, this.paymentableType)
      .subscribe((response) => {
        this.payments.splice(this.payments.indexOf(payment), 1);
        this.sumPaid();
      });
  }

  sumPaid() {
    this.paid = 0;
    this.payments.forEach((payment) => {
      this.paid += payment.amount * this.currencyRate;
    });
  }
}
